/**
 * AvatarPreview Component
 * Oluşturulan avatarın önizlemesi ve onay ekranı
 */

import React, { useState } from 'react';
import './AvatarPreview.css';

export interface AvatarData {
    avatarUrl: string;
    selfieUrl: string;
    gender: 'female' | 'male';
    bodyType: string;
    bodyTypeTitle: string;
    age?: number;
    height?: number;
    weight?: number;
}

interface AvatarPreviewProps {
    avatarData: AvatarData;
    onApprove: () => void;
    onReject: () => void;
    isLoading?: boolean;
}

export const AvatarPreview: React.FC<AvatarPreviewProps> = ({
    avatarData,
    onApprove,
    onReject,
    isLoading = false
}) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    const genderLabel = avatarData.gender === 'female' ? 'Kadın' : 'Erkek';

    return (
        <div className="avatar-preview">
            {/* Header */}
            <div className="avatar-preview__header">
                <h3 className="avatar-preview__title">Avatarınız Hazır!</h3>
                <p className="avatar-preview__subtitle">
                    Avatarınızı kontrol edin ve onaylayın
                </p>
            </div>

            {/* Avatar Display */}
            <div className="avatar-preview__display">
                {/* Main Avatar */}
                <div className="avatar-preview__main">
                    <div className={`avatar-preview__image-container ${imageLoaded ? 'loaded' : ''}`}>
                        {!imageLoaded && (
                            <div className="avatar-preview__skeleton">
                                <div className="avatar-preview__skeleton-pulse" />
                            </div>
                        )}
                        <img
                            src={avatarData.avatarUrl}
                            alt="Avatarınız"
                            className="avatar-preview__image"
                            onLoad={() => setImageLoaded(true)}
                        />

                        {/* PIP Selfie Overlay - Bottom Right */}
                        {imageLoaded && (
                            <div className="avatar-preview__pip-container">
                                <img
                                    src={avatarData.selfieUrl}
                                    alt="Original Selfie"
                                    className="avatar-preview__pip-selfie"
                                />
                            </div>
                        )}
                    </div>
                </div>

                </div>

            {/* Info Cards - array-driven with Google Material Symbols */}
            <div className="avatar-preview__info">
                {[
                    { icon: 'person', value: genderLabel, show: true },
                    { icon: 'cake', value: `${avatarData.age} yaş`, show: !!avatarData.age },
                    { icon: 'straighten', value: `${avatarData.height} cm`, show: !!avatarData.height },
                    { icon: 'fitness_center', value: `${avatarData.weight} kg`, show: !!avatarData.weight },
                ].filter(card => card.show).map((card, index) => (
                    <div key={index} className="avatar-preview__info-card">
                        <span className="material-symbols-outlined avatar-preview__info-icon">{card.icon}</span>
                        <div className="avatar-preview__info-content">
                            <span className="avatar-preview__info-value">{card.value}</span>
                        </div>
                    </div>
                ))}
            </div>

            {/* Success Note */}
            <div className="avatar-preview__success-note">
                <span className="avatar-preview__success-icon">💡</span>
                <p>Avatar kaydedilecek ve kıyafet denemeleri için kullanılacak.</p>
            </div>

            {/* Actions */}
            <div className="avatar-preview__actions">
                <button
                    className="avatar-preview__btn avatar-preview__btn--primary"
                    onClick={onApprove}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <span className="avatar-preview__btn-spinner" />
                            Kaydediliyor...
                        </>
                    ) : (
                        '✓ Onayla ve Devam Et'
                    )}
                </button>
                <button
                    className="avatar-preview__btn avatar-preview__btn--secondary"
                    onClick={onReject}
                    disabled={isLoading}
                >
                    🔄 Yeniden Oluştur
                </button>
            </div>
        </div>
    );
};

export default AvatarPreview;

